import { render, staticRenderFns } from "./LoanNotAllowedToSell.vue?vue&type=template&id=67185155"
import script from "./LoanNotAllowedToSell.vue?vue&type=script&lang=js"
export * from "./LoanNotAllowedToSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports